import cn from 'classnames';
import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

type BorderStyle = 'dashed' | 'solid';

type DividerProps = {
  borderStyle?: BorderStyle;
  margin?: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const borderStyleMap: Record<BorderStyle, string> = {
  dashed: 'dashed-border',
  solid: 'border-other-divider border-b border-solid',
};

/**
 * A reusable divider component that renders a horizontal line.
 */
const Divider: FC<DividerProps> = ({
  className,
  borderStyle = 'dashed',
  margin = 'my-3',
  ...otherProps
}) => {
  return (
    <span
      className={cn('block h-px w-full', borderStyleMap[borderStyle], margin, className)}
      data-test="divider"
      {...otherProps}
    />
  );
};

export default Divider;
